import type { TRemoteConfigVariantData } from 'helpers/getRemoteConfigVariantData'

export const mergeAbTestVariantData = (
  firebaseRemoteConfigVariantData: TRemoteConfigVariantData | null,
  growthbookVariantData: TRemoteConfigVariantData | null,
): TRemoteConfigVariantData => ({
  ...(firebaseRemoteConfigVariantData || {}),
  ...(growthbookVariantData || {}),
})
